import { Props } from './interfaces'
import * as Styled from './styled'

function EyeButton({ visibility, onClick }: Props) {
  return (
    <>
      {visibility ? (
        <Styled.HidePassword onClick={onClick} data-testid="toggle-password-visibility" />
      ) : (
        <Styled.ShowPassword onClick={onClick} data-testid="toggle-password-visibility" />
      )}
    </>
  )
}

export default EyeButton
